<template>
  <div class="wrapper" v-if="valid">
    <div v-if="config.linkType === 'button'" class="button-link" @click="openLink(config.link)"
         data-growing-container :data-growing-title="config.linkTitle">{{config.linkTitle}}</div>
    <div v-else class="text-link" @click="openLink(config.link)"
         data-growing-container :data-growing-title="config.linkTitle">{{config.linkTitle}}</div>
  </div>
</template>

<script>
const router = require("@/libs/router");

export default {
  props: ["config"],
  data() {
    return {
      valid: !this.config.link.url.startsWith("https://m2.ikea.cn") && !this.config.link.url.startsWith("https://www.ikea.cn")
    };
  },
  mounted() {},
  methods: {
    openLink(link) {
      router.open("link", {
        link: link
      });
    }
  }
};
</script>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
}
.button-link {
  display: inline-block;
  padding: 10px;
  font-size: 12px;
  line-height: 16px;
  color: #111111;
  font-weight: bold;
  min-width: 200px;
  border-radius: 24px;
  border: 1px solid #959595;
  text-align: center;
}
.text-link {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #0058a3;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/ButtonLinkComponent.vue